var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "price-wrapper" }, [
    _c(
      "span",
      {
        staticClass: "price",
        class: {
          up: +_vm.upDownPrev > 0,
          down: +_vm.upDownPrev < 0
        }
      },
      [
        _vm._v(
          _vm._s(
            _vm.activeTxPair && _vm.activeTxPair.closePrice
              ? _vm.activeTxPair.closePrice
              : ""
          )
        )
      ]
    ),
    _vm._v(" "),
    _c("span", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: +_vm.upDownPrev !== 0,
          expression: "+upDownPrev !== 0"
        }
      ],
      staticClass: "p-icon",
      class: {
        "up-icon": +_vm.upDownPrev > 0,
        "down-icon": +_vm.upDownPrev < 0
      }
    }),
    _vm._v(" "),
    _c("span", { staticClass: "real-price" }, [_vm._v(_vm._s(_vm.realPrice))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }